import React from 'react';

import Content from '@components/Dashboard/AdminPanel/Wallet';

const Wallet: React.FC = () => {
  return <Content />;
};

export default Wallet;
